import { Box, Center, Heading, Spinner, VStack } from "@chakra-ui/react";

import Form from "./Form";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useProduct from "./hooks/useProduct";
import { UpdateProductParams } from "@olagg/db-types";

const EditProduct = () => {
  const params = useParams();
  const id = params.id!
  const { editProduct, getProduct, product, isLoading } = useProduct();

  const onSubmit = async (data: UpdateProductParams) => {
    editProduct(id, data);
  }

  useEffect(() => {
    getProduct(id);
  }, [id])

  return (
    <>
      <Center w={'full'} pb={4}>
        <VStack color={'white'}>
          <Heading my={2}>
              Editar Producto
          </Heading>
          {
            isLoading ? (
              <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
                <Spinner />
              </Box>
            ) : (
              <Form product={product} onSubmit={onSubmit} />
            )
          }
        </VStack>
      </Center>
    </>
  )
}

export default EditProduct;